// Generated by scripts/generate-branded-icons.ts — do not edit by hand.
import Original from 'lucide-react/dist/esm/icons/list-end.js';

import { paths } from '../generated/list-end';
import { makeBrandedIcon } from '../make-branded';

export default makeBrandedIcon('list-end', Original, paths);
